import React, { Component } from 'react'
import score from 'src/helper/score'
import lang from '../lang'
import './index.less'

import { jumpToUser, jumpToRoom } from 'src/helper/webviewFun'

export default class extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    let thisNationalRank = this.props.thisNationalRank || []
    let lastUserRankList = this.props.lastUserRankList || []
    let myRankList = this.props.myRankList || {}
    let { language, lang } = this.props
    return (
      <div style={{ display: this.props.selectState === '0' ? 'block' : 'none' }}>
        <div className="treasures2">
          <div className="title">{lang.thisweek}</div>
          <div className="outer">
            {/* rankings-part */}
            <div className="rank-wrap" style={{ height: thisNationalRank.length > 3 ? '100%' : '11.62rem' }}>
              {/* 1 */}
              <div className="one-wrap">
                <div className="myone-avatar">
                  <div className="one-box"></div>
                  <img src={thisNationalRank && thisNationalRank.length > 0 && thisNationalRank[0].country_icon || '/img/de_img_logo.png'} alt="" className='ewioe' />
                </div>
                <div className="one-info">
                  <div>{thisNationalRank && thisNationalRank.length > 0 && thisNationalRank[0].country_name}</div>
                  <div className="money-info">
                    <img src="/img/activity/national/jb.png" alt="" />
                    <div className="money">{score(thisNationalRank && thisNationalRank.length > 0 && thisNationalRank[0].gold)}</div>
                  </div>
                </div>
              </div>
              {/* 2,3  */}
              <div className="others-box">
                <div className="two-box">
                  <div className="tx-box">
                    <div className="two-bj"></div>
                    <img src={thisNationalRank && thisNationalRank.length > 1 && thisNationalRank[1].country_icon || '/img/de_img_logo.png'} className="two-tx" alt="" />
                  </div>
                  <div className="two-info">
                    <div>{thisNationalRank && thisNationalRank.length > 1 && thisNationalRank[1].country_name}</div>
                    <div className="money-info">
                      <img src="/img/activity/national/jb.png" alt="" />
                      <div className="money">{score(thisNationalRank && thisNationalRank.length > 1 && thisNationalRank[1].gold)}</div>
                    </div>
                  </div>
                </div>


                <div className="three-box">
                  <div className="tx-box">
                    <div className="three-bj"></div>
                    <img src={thisNationalRank && thisNationalRank.length > 2 && thisNationalRank[2].country_icon || '/img/de_img_logo.png'} className="three-tx" alt="" />
                  </div>
                  <div className="three-info">
                    <div>{thisNationalRank && thisNationalRank.length > 2 && thisNationalRank[2].country_name}</div>
                    <div className="money-info">
                      <img src="/img/activity/national/jb.png" alt="" />
                      <div className="money">{score(thisNationalRank && thisNationalRank.length > 2 && thisNationalRank[2].gold)}</div>
                    </div>
                  </div>
                </div>

              </div>

              {/* 4-10 */}
              {thisNationalRank && thisNationalRank.length > 3 && (
                <div className={`remain1 ${language == 'ar' && 'arlang'}`}>
                  {/* 国家排名 */}
                  {thisNationalRank &&
                    thisNationalRank
                      .filter((ele, index) => {
                        return index > 2
                      })
                      .map((item, index) => {
                        if (index <= 6) {
                          return (
                            <div className="others-rank" key={index}>
                              <div className="rank-num">{index + 4}</div>
                              <div className="rank-user-box">
                                <div className="rank-user">
                                  <img src={item.country_icon} alt="" />
                                </div>
                                <div className="info">
                                  <div className="user-info">
                                    <div className="xinxi">
                                      <div className="name">{item.country_name}</div>
                                    </div>
                                    <div className="money">
                                      <img src="/img/activity/national/jb.png" alt="" />
                                      <div>{score(item.gold)}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        }
                      })}
                </div>
              )}
            </div>
          </div>
          {/* 我的国家排名 */}
          <div className="others-rank-my myrank">
            <div className="rank-num">{myRankList.rank || '0'}</div>
            <div className="rank-user-box">
              <div className="rank-user">
                <img src={myRankList.country_icon} alt="" />
              </div>
              <div className="info">
                <div className="user-info">
                  <div className="xinxi">
                    <div className="name">{myRankList.country_name}</div>
                  </div>
                  <div className="money">
                    <img src="/img/activity/national/jb.png" alt="" />
                    <div>{score(myRankList.gold)}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

{/* <div className="treasures">
          <div className="title">{lang.treasures}</div>
          <div className="box">
            <div className="desc">{lang.goldDesc}</div>
            <div className="money">
              <div className="num">{this.props.gemstoneValue}</div>
              <div className="gold">
                <img src="/img/activity/national/jb.png" alt="" />
              </div>
            </div>
            <div className="desc-main">
              <ul>
                <li>{lang.gd1}</li>
                <li>{lang.gd2}</li>
                <li>{lang.gd3}</li>
              </ul>
            </div>
            <div className="user">{lang.luck}</div>
            <div className="user-avatar-wrap">
              {lastUserRankList.map((item, index, arr) => {
                if (arr.length > 0) {
                  if (index <= 4) {
                    return (
                      <div className="avatar" key={index} onClick={jumpToUser.bind(this, item.uid)}>
                        <img src={item.avatarurl} className="pic" />
                        <div className="info">
                          <div className="icon"></div> <div className="xh">{score(item.value)}</div>
                        </div>
                      </div>
                    )
                  }
                }
              })}
            </div>
          </div>
        </div> */}


// WEBPACK FOOTER //
// src/pages/activity/national/Treasures/index.js